import { useEffect } from "react";

const SUFFIX = "Amazing Care";

/** Replaces Next.js `metadata` exports, which have no meaning in a SPA. */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} | ${SUFFIX}` : SUFFIX;
  }, [title]);
}
